import React, {memo} from "react";
import styles from "@/app/components/error_line/styles.module.scss";
import classNames from "classnames";

interface ErrorLineProps {
    error?: string | null;
    className: string;
}

const ErrorLine: React.FC<ErrorLineProps> = ({error: error, className: className}) => {

    return (
        <span className={classNames(styles.error, className, {[styles.hidden]: !error})}>{error ?? ""}</span>
    );
};

export default memo(ErrorLine);